import '@/assets/sass/now-ui-kit.scss';
// import '@/assets/css/bootstrap.css';
// import '@/assets/css/bootstrap.min.css';
// import '@/assets/css/bootstrap-rtl.css';
// import '@/assets/css/customForSwitch.css';
import '@/assets/sass/demo.scss';
import '@/assets/sass/now-ui-kit.scss';
import globalDirectives from './globalDirectives';
import globalMixins from './globalMixins';
import globalComponents from './globalComponents';
import lang from 'element-ui/lib/locale/lang/en';
import locale from 'element-ui/lib/locale';
import VueLazyload from 'vue-lazyload'

locale.use(lang);

export default {
    install(Vue) {
        Vue.use(globalDirectives);
        Vue.use(globalMixins);
        Vue.use(globalComponents);
        Vue.use(VueLazyload, {
          observer: true,
          // optional
          observerOptions: {
            rootMargin: '0px',
            threshold: 0.1
          }
        });
    }
}
